/** Task-grain field paths that more than one module has to agree on. Constants only, so the cell and
 * the fetch layer can both import them without importing each other. */

/** The Reported time column: the task's logged time. */
export const REPORTED_TIME_PATH = 'task.reported.time';

/** The flag the Reported time cell reads to decide whether to warn: true when logged time is over the
 * task's estimate, null when there is no estimate to compare against. */
export const OVER_ESTIMATE_PATH = 'task.derived.overEstimate';
